import classNames from "classnames"
import { AlertConfigurationModule } from "../types"
import Delay from "@/components/AlertSettingForms/Delay"
import GridItem from "@/components/shared/Grid/GridItem"
import {
   AlertConfigurationForm,
   AlertSystemCondition,
} from "@/types/alertConfigurations"

const MINIMUM_NO_VITALS_READINGS = 1

type NoVitalsSettingsProps = {
   disabled?: boolean
   loading: boolean
   updatingModule: string
   staticReadings: number
   wearableReadings: number
   systemCondition: AlertSystemCondition
   handleSave: (
      state: Partial<AlertConfigurationForm>,
      configurationModule: AlertConfigurationModule
   ) => void
}

function NoVitalsSettings({
   disabled = false,
   loading,
   updatingModule,
   staticReadings,
   wearableReadings,
   systemCondition,
   handleSave,
}: NoVitalsSettingsProps) {
   const sectionClassName = classNames({
      "alert-setting-detail__section--disabled": disabled,
   })

   return (
      <>
         <GridItem
            size={12}
            className={classNames({
               "alert-setting-detail__section--disabled": disabled,
            })}
         >
            <Delay
               title="Static sensor readings"
               description="Number of readings from the Static Sensor in the cell, before the alarm triggers"
               minimumDelayPeriod={MINIMUM_NO_VITALS_READINGS}
               iconName="cell"
               loading={
                  loading &&
                  updatingModule ===
                     AlertConfigurationModule.NO_VITALS_STATIC_READINGS
               }
               delayPeriod={staticReadings}
               onSave={(value) => {
                  handleSave(
                     {
                        systemCondition: {
                           ...systemCondition,
                           mainThreshold: value,
                        },
                     },
                     AlertConfigurationModule.NO_VITALS_STATIC_READINGS
                  )
               }}
            />
         </GridItem>
         <GridItem
            size={12}
            className={sectionClassName}
         >
            <Delay
               title="ReassureBand readings"
               description="Number of readings from the ReassureBand, before the alarm triggers"
               minimumDelayPeriod={MINIMUM_NO_VITALS_READINGS}
               iconName="smartwatch"
               loading={
                  loading &&
                  updatingModule ===
                     AlertConfigurationModule.NO_VITALS_WEARABLE_READINGS
               }
               delayPeriod={wearableReadings}
               onSave={(value) => {
                  handleSave(
                     {
                        systemCondition: {
                           ...systemCondition,
                           secondaryThreshold: value,
                        },
                     },
                     AlertConfigurationModule.NO_VITALS_WEARABLE_READINGS
                  )
               }}
            />
         </GridItem>
      </>
   )
}

export default NoVitalsSettings
